import axiosClient from '../client'

export const showUser = id => axiosClient().get(`/users/${id}`)

export const updateUser = (id, data) => axiosClient().put(`/users/${id}`, { user: data })

export const resendConfirmationCode = id => axiosClient().get(`/users/${id}/resend_confirmation_code`)

export const verifyUserEmail = (id, code) => axiosClient().post(`/users/${id}/verify_email`, { code })
